import React, {useEffect, useRef, useState} from "react";
import {Formik} from "formik";
import ReactHtmlParser from 'react-html-parser';

import step from "../StepOne/styles/step.module.scss";
import styles from "./styles/styles.module.scss";
import { FieldNumber, FieldCheckbox } from "../";
import { useCalc } from "../../store/hooks/useCalc";
import { objIsEmpty } from "../../helpers";
import { validationBet } from "./validationBet";
import { scrollToRef } from "../../helpers/scrollToRef";

import text from "../../helpers/useText";

export const StepTwo = () => {
  let stepTwoRef = useRef();
  const { setStepTwoData, clearStepTwoData, fields, initialValues, stepOneData } = useCalc();
  const [toggleBets, setToggleBets] = useState(false);
  const [fieldsData, setFieldsData] = useState(stepOneData);

  useEffect(() => {
    if (fieldsData.size !== stepOneData.size || fieldsData.max !== stepOneData.max || fieldsData.bet !== stepOneData.bet) {
      setToggleBets(false);
      setFieldsData(stepOneData);
      scrollToRef(stepTwoRef);
    }
  }, [fieldsData, stepTwoRef, stepOneData]);

  useEffect(() => {
    scrollToRef(stepTwoRef);
  }, [stepTwoRef]);

  let successBets = 0;
  let errorForm = '';

  const toggleAllBetsSuccess = (e, setFieldValue, setFieldTouched) => {
    e.preventDefault();
    if (!toggleBets) {
      fields.map(item => {
        setFieldValue(`betStatus${item}`, true);
        setFieldTouched(`bet${item}`, true);
        return true;
      });
    } else {
      fields.map(item => {
        setFieldValue(`betStatus${item}`, false);
        setFieldTouched(`bet${item}`, true);
        return true;
      });
    }
    setToggleBets(!toggleBets);
  };

  const submitForm = (values, actions) => {
    setStepTwoData(values);
    //showStepThree(true);
    actions.setSubmitting(false);
  };

  const handlerClear = (e, resetForm) => {
    e.preventDefault();
    resetForm({});
    clearStepTwoData();
    setToggleBets(false);
    //showStepThree(false);
  };

  const updateCounter = (values) => {
    const entries = Object.entries(values);
    successBets = entries.reduce((count, [ k, v ]) => {
      (v === true) && count++;
      return count;
    }, 0);
  };

  const setFormError = (errors) => {
    if ( !objIsEmpty(errors) ) {
      errorForm = text.stepTwo.error;
    } else {
      errorForm = '';
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={ initialValues }
      //validationSchema={ validationForm }
      onSubmit={ (values, actions) => submitForm(values, actions) }>
      {
        props => {
          const { values, errors, handleSubmit, handleChange, setFieldValue, setFieldTouched, resetForm, submitCount } = props;

          setFormError(errors);
          updateCounter(values);


          return (
            <div className={styles.step_two} ref={stepTwoRef}>
              <div className={step.step__header}>
                <div className={step.step__title}>{text.stepTwo.title}</div>
                <div className={step.step__header_action}>
                  <div className={step.step__reset} onClick={(e) => handlerClear(e, resetForm)}><span className="ico-reset"/>{text.clearBtnText}</div>
                </div>
              </div>
              <div className={step.step__description}>
                { ReactHtmlParser(text.stepTwo.description) }
              </div>
              <div className={styles.step_two__content}>
                <form className={styles.form} onSubmit={handleSubmit}>
                  <div className={styles.form__content}>
                    {
                      fields.map((item) => {
                        return (
                          <div className={styles.form__field} key={`bet${item}`}>
                            <div className={`${styles.form__field_bet} ${values[`betStatus${item}`] ? `${styles.form__field_bet_success}` : ''}`}>
                              <FieldNumber
                                id={`bet${item}`}
                                name={`bet${item}`}
                                autoComplete={`bet${item}`}
                                label={item+1}
                                type="text"
                                value={values[`bet${item}`]}
                                onChange={handleChange}
                                validate={validationBet}
                              />
                            </div>
                            <div className={styles.form__field_status}>
                              <FieldCheckbox
                                name={`betStatus${item}`}
                                id={`betStatus${item}`}
                                value={values[`betStatus${item}`]}
                                checked={values[`betStatus${item}`] ? 'checked': ''}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                  {
                    <div className={styles.form__error}>
                      { errorForm && errorForm }
                    </div>
                  }
                  <div className={styles.form__footer}>
                    <div className={styles.step_two__status}>
                      <span/>
                      <div className={styles.step_two__status_text}>{`${successBets}/${fields.length}`} {text.stepTwo.steps}</div>
                    </div>
                    <div className={styles.form__footer_actions}>
                      <button className="c-btn c-btn--primary" type="button" onClick={(e) => toggleAllBetsSuccess(e, setFieldValue, setFieldTouched)}>
                        <div className="c-btn__text">{toggleBets ? text.stepTwo.remove : text.stepTwo.mark}</div>
                      </button>
                      <button className="c-btn" type="submit" data-id="to-login">
                        <div className="c-btn__text">{submitCount > 0 ? text.stepTwo.resettle : text.stepTwo.settle}</div>
                      </button>
                    </div>

                  </div>
                </form>
              </div>
            </div>
          )
        }
      }
    </Formik>
  )
};
